import { StyledParametersWrapper } from './CorellationParametersSectionStyles';
import CorrelationParameters from './CorrelationParameters';
import SubmittedCorellations from './SubmittedCorellations';

const CorrelationParametersSection = () => {
  return (
    <StyledParametersWrapper>
      <SubmittedCorellations />
      <CorrelationParameters />
    </StyledParametersWrapper>
  );
};

export default CorrelationParametersSection;
